import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {lazyInject} from "@intelingu/core/IoC/container";
import {UserStore} from "@intelingu/core/stores/UserStore";
import {UserApi} from "@intelingu/core/api/UserApi";
import {LoginFormComponent} from "./LoginFormComponent";
import withTranslation from "@intelingu/core/utils/withTranslation";
import {COMMON_NS} from "@intelingu/core/constants/base.constants";
import {Link} from "react-router-dom";
import {when} from "mobx";
import {SubscriptionsApi} from "@intelingu/core/api/SubscriptionsApi";

interface SubscribeRedirectPageProps {
    t?;
}

function findGetParameter(parameterName) {
    let result = null;
    let tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) {
                result = decodeURIComponent(tmp[1]);
            }
        });
    return result;
}

@withTranslation(COMMON_NS)
@observer export class SubscribeRedirectPage extends Component<SubscribeRedirectPageProps, any> {

    waiter;

    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(UserApi) userApi: UserApi;
    @lazyInject(SubscriptionsApi) subscriptionsApi: SubscriptionsApi;

    componentDidMount() {
        if (this.userStore.user) {
            this.trackAndRedirect();
        } else {
            this.waiter = when(() => !!this.userStore.user, () => {
                this.trackAndRedirect();
            })
        }
    }

    componentWillUnmount() {
        if (this.waiter) {
            this.waiter();
        }
    }

    async trackAndRedirect() {
        const productId = findGetParameter('product_id');
        const ds24tr = findGetParameter('ds24tr');

        // window.location.href = 'https://www.digistore24.com/product/' + window.location.href.split('=')[1];
        const response = await this.subscriptionsApi.subscribe(Number(productId), true);

        if (response.data.url) {
            let redirectUrl = response.data.url;

            if (ds24tr && ds24tr.length) {
                redirectUrl += '?ds24tr=' + ds24tr;
            }

            window.location.href = redirectUrl;
        } else {
            alert('Unknown error. Please, contact support!');
        }
    }

    render() {
        const { t } = this.props;

        return <div className={'session-page'}>
            { !this.userStore.user ? (
                <>
                    <h1>{ t('sessionLogInWith') }:</h1>

                    <p className={'mb-3 mt-2'}>Melde dich zunächst in deinem Nutzerkonto an, um die Vollversion zum Aktionspreis zu aktivieren:</p>

                    <div className={'sep mb-4'} />

                    <LoginFormComponent />

                    <div className={'bottom-links'}>
                        <Link to={'/session/reset'}>{ t('sessionForgotPasswordLink') }</Link>
                    </div>
                </>
            ) : (
                <h2>Einen Augenblick bitte...</h2>
            ) }
        </div>
    }

}
